import React, { useContext } from 'react';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { QuickAppointmentContext } from '../../Context';
import useStyles from '../styles';

const SearchResult = ({ results, search_query, allowCreate }) => {
  const classes = useStyles();
  const labelCheck = search_query;
  const allCustomers = results.filter(
    (result) => !result.has_appointment_today,
  );
  const todaysCustomers = results.filter(
    (result) => result.has_appointment_today,
  );
  const {
    setContactData,
    getSearchData,
    setActiveStep,
    setCustomerType,
    setCompletedSteps,
  } = useContext(QuickAppointmentContext);

  const fillName = (data) => {
    if (data.includes('@')) {
      setContactData({
        email: data,
      });
    } else {
      let [first_name, ...last_name] = data.split(' ');
      last_name = last_name.join(' ');
      setContactData({
        first_name,
        last_name,
      });
    }
    setActiveStep(0);
  };

  const fillSearchData = (customer_id) => {
    getSearchData(customer_id);
    setCustomerType('existing');
    setActiveStep(1);
    setCompletedSteps((prev) => ({ ...prev, 0: true }));
  };

  const getFleetPrefix = ({ fleet_account_name }) =>
    fleet_account_name ? `${fleet_account_name} - ` : '';
  const getResultString = (result) => {
    const { first_name, last_name, email, phone } = result;
    return `${getFleetPrefix(
      result,
    )}${first_name} ${last_name} - ${email} ${phone}`;
  };

  return (
    <Box
      className={
        allowCreate
          ? `${classes.searchResult} ${classes.searchResultAllowCreate}`
          : classes.searchResult
      }
    >
      <List>
        <>
          {allowCreate && (
            <>
              <ListItem
                className={classes.resultList}
                onClick={() => fillName(labelCheck)}
              >
                <Typography variant="body2">Create New Customer: </Typography>
                <Box
                  className={classes.previewLabel}
                  title={labelCheck.length > 37 ? labelCheck : ''}
                >
                  {labelCheck}
                </Box>
              </ListItem>
              <Divider className={classes.listDivider} />
            </>
          )}
          {todaysCustomers.length > 0 && allowCreate && (
            <Typography
              variant="subtitle2"
              gutterBottom
              className={classes.resultTitle}
            >
              Today&apos;s Customers
            </Typography>
          )}
          {todaysCustomers.map((result) => {
            return (
              <ListItem
                className={classes.optionList}
                key={result.user_id}
                onClick={() => fillSearchData(result.customer_id)}
              >
                <Box
                  className={classes.InfoWrapper}
                  title={getResultString(result)}
                >
                  <Box className={classes.resultLabel}>
                    {getFleetPrefix(result)}
                    {result.first_name} {result.last_name}
                  </Box>
                  <Box className={classes.resultInfo}>{result.email}</Box>
                  <Box className={classes.resultInfo}>{result.phone}</Box>
                </Box>
              </ListItem>
            );
          })}
          {allCustomers.length > 0 && allowCreate && (
            <Typography
              variant="subtitle2"
              gutterBottom
              className={classes.resultTitle}
            >
              All Customers
            </Typography>
          )}
          {allCustomers.map((result) => {
            return (
              <ListItem
                className={classes.optionList}
                key={result.user_id}
                onClick={() => fillSearchData(result.customer_id)}
              >
                <Box
                  className={classes.InfoWrapper}
                  title={getResultString(result)}
                >
                  <Box className={classes.resultLabel}>
                    {getFleetPrefix(result)}
                    {result.first_name} {result.last_name}
                  </Box>
                  <Box className={classes.resultInfo}>{result.email}</Box>
                  <Box className={classes.resultInfo}>{result.phone}</Box>
                </Box>
              </ListItem>
            );
          })}
          <Divider className={classes.listDivider} />
        </>
      </List>
    </Box>
  );
};

export default SearchResult;
